import { useUser } from '#imports';

import Cookies from 'js-cookie';
/**
 * Extended user composable that adds additional functionality to the default useUser composable
 * @returns Extended user composable with all original functions plus the new ones
 */
export function useUserExtended() {
    // Get all methods and properties from the original useUser composable
    const userComposable = useUser();

    /**
     * Refreshes user data with common associations for addresses, countries, and salutations
     * This is a convenience method to avoid repeating the same association structure
     * @returns Promise with the refreshed user data
     */
    const refreshUserWithAssociations = async () => {
        return await userComposable.refreshUser({
            associations: {
                defaultBillingAddress: {
                    associations: {
                        country: {},
                        salutation: {},
                    },
                },
                defaultShippingAddress: {
                    associations: {
                        country: {},
                        salutation: {},
                    },
                },
            },
        });
    };

    const setUserCookies = (user: any) => {
        Cookies.set(
            'userCookies',
            JSON.stringify({
                firstName: user?.value?.firstName,
            }),
            {
                expires: 365, // days
                secure: true, // HTTPS only
                path: '/',
                sameSite: 'lax',
            },
        );
    };

    const destroyUserCookies = () => {
        Cookies.remove('userCookies', { path: '/' });
    };

    const userCookies = computed(() => (Cookies.get('userCookies') ? JSON.parse(Cookies.get('userCookies')) : null));

    // Return all original properties and methods plus the new ones
    return {
        ...userComposable,
        refreshUserWithAssociations,
        setUserCookies,
        destroyUserCookies,
        userCookies,
    };
}

export default useUserExtended;
